module.exports = __webpack_public_path__ + "img/icon-search-a086cbde.svg";